import * as React from 'react';
import { SVGProps } from 'react';

const IconFoldersSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 1a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H6a1 1 0 0 0-1-1H3z" />
    <path d="M1 4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1H2a1 1 0 0 1-1-1V4z" />
  </svg>
);
export default IconFoldersSizeXs;
